<!-- PLEASE READ: this component is used in multiple places. Plese be careful about
     adding padding to the outer div that will break other UIs.

     Be careful when modifying this. It's used in multiple places. You should prob QA all
     of them if you modify. Some places it's used:

     - feed

     - post-thread component (i.e. single post thread view... note that there's a different
       treatment for parents vs comments, based on the isParentPostInThread variable)

     - feed-create-comment-form component (i.e. create comment view)

     - market-feed component -->
<div
  class="d-flex flex-column"
  [ngClass]="{
    'br-12px': setBorder || cardStyle,
    'm-15px': cardStyle && !isQuotedContent,
    'js-feed-post-hover': hoverable,
    border: setBorder || cardStyle,
    'feed-post__quoted-content': hoverable && isQuotedContent
  }"
>
  <div class="w-100">
    <div
      *ngIf="post.IsHidden"
      class="p-10px background-color-grey d-flex align-items-center justify-content-center fs-15px"
    >
      <a
        (click)="onPostClicked($event)"
        class="link--unstyled"
        [routerLink]="
          getRouterLink(['/' + globalVars.RouteNames.POSTS, post.PostHashHex])
        "
        queryParamsHandling="merge"
      >
        This post was removed by the author.
      </a>
    </div>

    <div
      *ngIf="globalVars.hasUserBlockedCreator(post.PosterPublicKeyBase58Check)"
      class="p-15px background-color-grey d-flex align-items-center justify-content-center fs-15px"
    >
      <a
        class="link--unstyled"
        style="text-align: center"
        [routerLink]="
          getRouterLink([
            '/' + globalVars.RouteNames.USER_PREFIX,
            post.ProfileEntryResponse.Username
          ])
        "
        queryParamsHandling="merge"
      >
        This is a post from {{ post.ProfileEntryResponse.Username }} who you
        have blocked. Click here to visit their profile to unblock them.
      </a>
    </div>

    <div
      *ngIf="
        !post.IsHidden &&
        !hidingPost &&
        !globalVars.hasUserBlockedCreator(
          postContent.PosterPublicKeyBase58Check
        )
      "
      class="d-flex flex-column js-feed-post"
      [ngStyle]="{ 'border-radius': setBorder ? '12px 12px 0 0' : '' }"
    >
      <a
        (click)="onPostClicked($event)"
        Class="link--unstyled"
        [ngClass]="{
          'cursor-inherit': !contentShouldLinkToThread
        }"
      >
        <div
          *ngIf="showReplyingTo && post.ParentStakeID != ''"
          class="pl-15px pt-5px align-items-center"
          style="margin-bottom: -5px"
        >
          <a
            class="fc-muted font-weight-semibold fs-15px"
            queryParamsHandling="merge"
            [routerLink]="
              getRouterLink([
                '/' + globalVars.RouteNames.USER_PREFIX,
                post.ParentPosts[0].ProfileEntryResponse.Username
              ])
            "
          >
            replying to {{ post.ParentPosts[0].ProfileEntryResponse.Username }}
          </a>
        </div>
        <div
          *ngIf="reposterProfile"
          class="feed-post__container d-flex justify-content-left w-100 pb-5px"
          [ngClass]="{
            'feed-post__blue-border': showLeftSelectedBorder,
            'feed-post__parent-post-font-size': isParentPostInThread,
            'px-15px': includePaddingOnPost,
            'pt-10px': includePaddingOnPost
          }"
        >
          <a
            class="fc-muted font-weight-semibold align-items-center"
            queryParamsHandling="merge"
            [routerLink]="
              getRouterLink([
                '/' + globalVars.RouteNames.USER_PREFIX,
                reposterProfile.Username
              ])
            "
          >
            <i class="icon-repost fs-20px" style="vertical-align: middle"></i>
            <span style="vertical-align: middle" class="fs-15px"
              >@{{ reposterProfile.Username }} reposted</span
            >
          </a>

          <feed-post-dropdown
            *ngIf="showDropdown"
            class="ml-auto"
            [post]="post"
            [postContent]="postContent"
            [nftEntryResponses]="nftEntryResponses"
            (postHidden)="hidePost()"
            (userBlocked)="blockUser()"
            (toggleGlobalFeed)="_addPostToGlobalFeed()"
            (refreshNFTEntries)="refreshNFTEntriesHandler()"
          ></feed-post-dropdown>
        </div>

        <div
          *ngIf="postContent.IsHidden"
          class="p-10px background-color-grey d-flex align-items-center justify-content-center fs-15px"
          [ngClass]="{
            'px-15px': includePaddingOnPost,
            'pb-15px': includePaddingOnPost,
            'pt-15px': includePaddingOnPost && !reposterProfile,
            'feed-post__blue-border': showLeftSelectedBorder,
            'feed-post__parent-post-font-size': isParentPostInThread
          }"
        >
          <a
            (click)="onPostClicked($event)"
            class="link--unstyled"
            [routerLink]="
              getRouterLink([
                '/' + globalVars.RouteNames.POSTS,
                postContent.PostHashHex
              ])
            "
            queryParamsHandling="merge"
          >
            The original post was removed by its author.
          </a>
        </div>

        <ng-template #creatorCoinInfo>
          <!-- Coin price-->
          <a
            style="padding: 3px"
            class="creator-coin-info fs-12px font-weight-bold feed-post__coin-price-holder br-12px"
            [routerLink]="
              getRouterLink(
                AppRoutingModule.buyCreatorPath(
                  postContent.ProfileEntryResponse.Username
                )
              )
            "
            queryParamsHandling="merge"
          >
            <span class="text-grey5">
              ~{{
                globalVars.nanosToUSD(
                  postContent.ProfileEntryResponse.CoinPriceDeSoNanos,
                  2
                )
              }}
            </span>

            <!-- Buy link -->
            Buy
          </a>
        </ng-template>

        <div
          class="feed-post__container d-flex justify-content-left w-100"
          [ngClass]="{
            'px-15px': includePaddingOnPost,
            'pb-15px': includePaddingOnPost,
            'pt-15px': includePaddingOnPost && !reposterProfile,
            'feed-post__blue-border': showLeftSelectedBorder,
            'feed-post__parent-post-font-size': isParentPostInThread
          }"
          [ngStyle]="{
            'border-radius':
              showLeftSelectedBorder && cardStyle
                ? postContent.IsNFT && showNFTDetails
                  ? '12px 0'
                  : '12px'
                : ''
          }"
          *ngIf="!postContent.IsHidden"
        >
          <!-- Avatar -->
          <div class="feed-post__avatar-container">
            <a
              class="feed-post__avatar br-12px"
              [avatar]="postContent.ProfileEntryResponse.PublicKeyBase58Check"
              [routerLink]="
                getRouterLink([
                  '/' + globalVars.RouteNames.USER_PREFIX,
                  postContent.ProfileEntryResponse.Username
                ])
              "
              queryParamsHandling="merge"
            ></a>
            <div
              *ngIf="showThreadConnectionLine"
              class="feed-post__parent-thread-connector"
            ></div>
          </div>

          <!-- Main Content -->
          <div class="w-100">
            <div class="d-flex align-items-center">
              <!-- Username-->
              <a
                class="fc-default font-weight-bold"
                [routerLink]="
                  getRouterLink([
                    '/' + globalVars.RouteNames.USER_PREFIX,
                    postContent.ProfileEntryResponse.Username
                  ])
                "
                queryParamsHandling="merge"
              >
                {{ postContent.ProfileEntryResponse.Username }}
              </a>

              <span
                *ngIf="postContent.ProfileEntryResponse.IsVerified"
                class="ml-1 text-primary"
              >
                <i class="fas fa-check-circle fa-md align-middle"></i>
              </span>
              <div class="desktop-creator-coin-info">
                <ng-container
                  *ngTemplateOutlet="creatorCoinInfo"
                ></ng-container>
              </div>

              <!-- Desktop follow button-->
              <follow-button
                *ngIf="!hideFollowLink"
                class="ml-10px fs-12px d-lg-block d-none text-grey5"
                [displayAsLink]="true"
                [followLinkClass]="'link--unstyled'"
                [followedPubKeyBase58Check]="
                  postContent.ProfileEntryResponse.PublicKeyBase58Check
                "
                [creatorCoinTemplate]="creatorCoinInfo"
              ></follow-button>

              <div class="ml-auto">
                <div
                  *ngIf="getNode()"
                  class="d-inline-block mr-5px"
                  [ngClass]="{
                    'mr-5px': globalVars.isMobile(),
                    'mr-10px': !globalVars.isMobile()
                  }"
                >
                  <a
                    class="text-grey9"
                    target="_blank"
                    href="{{ getNode().URL }}"
                    matTooltipClass="global__mat-tooltip global__mat-tooltip-font-size"
                    mat-raised-button
                    #tooltip="matTooltip"
                    [matTooltip]="'Posted on ' + getNode().Name"
                  >
                    <i class="fas fa-external-link-square-alt"></i>
                  </a>
                </div>

                <feed-post-dropdown
                  *ngIf="showDropdown && !reposterProfile"
                  class="d-inline-block"
                  [post]="post"
                  [postContent]="postContent"
                  [nftEntryResponses]="nftEntryResponses"
                  (postHidden)="hidePost()"
                  (userBlocked)="blockUser()"
                  (toggleGlobalFeed)="_addPostToGlobalFeed($event)"
                  (togglePostPin)="_pinPostToGlobalFeed($event)"
                  (refreshNFTEntries)="refreshNFTEntriesHandler()"
                ></feed-post-dropdown>
              </div>
            </div>

            <!-- Mobile follow button-->
            <div class="mt-5px d-lg-none text-grey5">
              <follow-button
                *ngIf="!hideFollowLink"
                class="fs-12px"
                [displayAsLink]="true"
                [followLinkClass]="'link--unstyled'"
                [followedPubKeyBase58Check]="
                  postContent.ProfileEntryResponse.PublicKeyBase58Check
                "
                [creatorCoinTemplate]="creatorCoinInfo"
              ></follow-button>
            </div>

            <div
              *ngIf="showReplyingToContent"
              class="fs-13px text-muted pt-1 pb-2"
            >
              replying to
              <a
                [routerLink]="
                  getRouterLink([
                    '/' + this.globalVars.RouteNames.USER_PREFIX,
                    parentPost.ProfileEntryResponse.Username
                  ])
                "
                queryParamsHandling="merge"
              >
                @{{ parentPost.ProfileEntryResponse.Username }}
              </a>
            </div>

            <!-- Content -->
            <div
              class="roboto-regular mt-1"
              [ngClass]="{ 'mb-10px': quotedContent && showQuotedContent }"
              style="
                overflow-wrap: anywhere;
                word-break: break-word;
                outline: none;
              "
              [innerHTML]="postContent.Body | sanitizeAndAutoLink"
              queryParamsHandling="merge"
            ></div>

            <!-- Media -->
            <div
              *ngIf="postContent.ImageURLs && postContent.ImageURLs[0]"
              class="feed-post__image-container"
              [ngClass]="{ 'mb-10px': quotedContent && showQuotedContent }"
            >
              <img
                (click)="openImgModal($event, postContent.ImageURLs[0])"
                data-toggle="modal"
                class="feed-post__image"
                src="{{ mapImageURLs(postContent.ImageURLs[0]) }}"
              />
            </div>

            <!-- Video -->
            <div
              *ngIf="postContent.VideoURLs && postContent.VideoURLs[0]"
              class="feed-post__video-container"
              [ngClass]="{ 'mb-10px': quotedContent && showQuotedContent }"
            >
              <iframe
                [src]="postContent.VideoURLs[0] | sanitizeVideoUrl"
                allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                allowfullscreen
                class="feed-post__video"
              >
              </iframe>
            </div>

            <!-- Embedded Content -->
            <div
              *ngIf="constructedEmbedURL"
              class="feed-post__embed-container"
              [ngClass]="{ 'mb-10px': quotedContent && showQuotedContent }"
            >
              <iframe
                id="embed-iframe"
                [height]="getEmbedHeight()"
                class="feed-post__image"
                [ngStyle]="{
                  'margin-top': setNegativeMargins(
                    constructedEmbedURL,
                    globalVars
                  )
                    ? '-65px'
                    : '',
                  'margin-bottom': setNegativeMargins(
                    constructedEmbedURL,
                    globalVars
                  )
                    ? '-65px'
                    : '',
                  'max-width': getEmbedWidth(constructedEmbedURL)
                }"
                [src]="constructedEmbedURL | sanitizeEmbed"
                frameborder="0"
                allow="picture-in-picture; clipboard-write; encrypted-media; gyroscope; accelerometer; encrypted-media;"
                allowfullscreen
              ></iframe>
            </div>

            <feed-post
              *ngIf="quotedContent && showQuotedContent"
              [post]="quotedContent"
              [isQuotedContent]="true"
              [includePaddingOnPost]="true"
              [showIconRow]="false"
              [showDropdown]="false"
              [showQuotedContent]="false"
              [contentShouldLinkToThread]="contentShouldLinkToThread"
              [hoverable]="hoverable"
              [showNFTDetails]="true"
              [cardStyle]="true"
            ></feed-post>

            <!-- Bottom Buttons -->
            <div
              *ngIf="!showInteractionDetails"
              class="feed-post__icon-row-holder"
            >
              <!-- Like, Comment, Repost, Share Buttons -->
              <feed-post-icon-row
                *ngIf="showIconRow"
                [post]="post"
                [postContent]="postContent"
                [parentPost]="parentPost"
                [afterCommentCreatedCallback]="afterCommentCreatedCallback"
                [afterRepostCreatedCallback]="afterRepostCreatedCallback"
                [inTutorial]="inTutorial"
                (diamondSent)="diamondSent.emit()"
              ></feed-post-icon-row>

              <!-- Admin Buttons -->
              <div
                *ngIf="showAdminRow"
                class="pt-10px fs-15px d-flex align-items-center"
              >
                <div
                  *ngIf="!postContent.InGlobalFeed && !addingPostToGlobalFeed"
                  (click)="_addPostToGlobalFeed($event)"
                  class="py-5px px-10px admin__add-to-feed-button"
                >
                  <i class="fas fa-folder-plus"></i>
                  Add to global feed
                </div>
                <div
                  *ngIf="!postContent.InGlobalFeed && addingPostToGlobalFeed"
                  class="py-5px px-10px admin__add-to-feed-button"
                >
                  <i class="fas fa-folder-plus"></i>
                  Adding...
                </div>
                <div
                  *ngIf="postContent.InGlobalFeed && !addingPostToGlobalFeed"
                  (click)="_addPostToGlobalFeed($event)"
                  class="py-5px px-10px admin__remove-from-feed-button"
                >
                  <i class="fas fa-check"></i>
                  On global feed
                </div>
                <div
                  *ngIf="postContent.InGlobalFeed && addingPostToGlobalFeed"
                  class="py-5px px-10px admin__remove-from-feed-button"
                >
                  <i class="fas fa-check"></i>
                  Removing...
                </div>

                <div>
                  &nbsp;&middot;
                  <a
                    [routerLink]="
                      getRouterLink([
                        '/' + globalVars.RouteNames.POSTS,
                        postContent.PostHashHex
                      ])
                    "
                    queryParamsHandling="merge"
                  >
                    View
                  </a>
                </div>

                <div class="text-grey8A">
                  &nbsp;&middot;&nbsp;{{
                    globalVars.convertTstampToDaysOrHours(
                      postContent.TimestampNanos
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </a>
      <!--
        This HTML is used on the main post in a thread in order to show detailed info
        about the interactions with that thread.  TODO: We should probably break the
        "main" post in a thread into it's own file so it can have more custom styling
        with less code complexity.
      -->
      <div
        class="feed-post__blue-border px-30px pb-5px"
        *ngIf="showInteractionDetails"
      >
        <div class="container w-100 p-0px">
          <!-- DESKTOP -->
          <div
            class="row no-gutters d-none d-lg-block py-10px fs-15px border-top border-bottom border-color-light-grey cursor-pointer"
          >
            <div class="d-flex justify-content-between">
              <span
                (click)="openRepostsModal($event)"
                class="interaction-detail"
              >
                <b>{{ globalVars.abbreviateNumber(post.RepostCount) }}</b>
                Reposts&nbsp;
              </span>
              <span
                (click)="openQuoteRepostsModal($event)"
                class="interaction-detail"
              >
                <b>{{ globalVars.abbreviateNumber(post.QuoteRepostCount) }}</b>
                Quote Reposts&nbsp;
              </span>
              <span (click)="openLikesModal($event)" class="interaction-detail">
                <b>{{ globalVars.abbreviateNumber(post.LikeCount) }}</b>
                Likes
              </span>
              <span
                (click)="openDiamondsModal($event)"
                class="interaction-detail"
              >
                <b>{{ globalVars.abbreviateNumber(post.DiamondCount) }}</b>
                Diamonds
              </span>
            </div>
          </div>
          <!-- MOBILE -->
          <div
            class="row no-gutters d-lg-none py-10px fs-15px border-top border-bottom border-color-light-grey cursor-pointer"
          >
            <div
              class="col-6 mb-0 interaction-detail"
              (click)="openRepostsModal($event)"
            >
              <b>{{ globalVars.abbreviateNumber(postContent.RepostCount) }}</b>
              Reposts&nbsp;
            </div>
            <div
              class="col-6 mb-0 interaction-detail"
              (click)="openQuoteRepostsModal($event)"
            >
              <b>{{
                globalVars.abbreviateNumber(postContent.QuoteRepostCount)
              }}</b>
              Quote Reposts&nbsp;
            </div>
          </div>
          <div
            class="row no-gutters d-lg-none py-10px fs-15px border-bottom border-color-light-grey cursor-pointer"
          >
            <div
              (click)="openLikesModal($event)"
              class="col-6 mb-0 interaction-detail"
            >
              <b>{{ globalVars.abbreviateNumber(postContent.LikeCount) }}</b>
              Likes
            </div>
            <div
              (click)="openDiamondsModal($event)"
              class="col-6 mb-0 interaction-detail"
            >
              <b>{{ globalVars.abbreviateNumber(postContent.DiamondCount) }}</b>
              Diamonds
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="showInteractionDetails"
        class="feed-post__container d-flex justify-content-left w-100"
        [ngClass]="{
          'px-15px': includePaddingOnPost,
          'pb-15px': includePaddingOnPost,
          'feed-post__blue-border': showLeftSelectedBorder,
          'feed-post__parent-post-font-size': isParentPostInThread
        }"
      >
        <div class="feed-post__avatar-container"></div>
        <div class="w-100" style="margin-left: -5px">
          <feed-post-icon-row
            class="mt-2px"
            *ngIf="showIconRow"
            [post]="post"
            [postContent]="postContent"
            [parentPost]="parentPost"
            [hideNumbers]="true"
            [afterCommentCreatedCallback]="afterCommentCreatedCallback"
            [afterRepostCreatedCallback]="afterRepostCreatedCallback"
            (diamondSent)="diamondSent.emit()"
          ></feed-post-icon-row>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="showNFTDetails && postContent.IsNFT"
    class="p-15px fs-15px w-100 background-color-grey"
    [ngStyle]="{
      'border-radius': setBorder || cardStyle ? '0 0 12px 12px' : ''
    }"
    [ngClass]="{ 'feed-post__blue-border': showLeftSelectedBorder }"
  >
    <div
      class="d-flex justify-content-between"
      [ngClass]="{
        'flex-column': isQuotedContent,
        'align-items-start': isQuotedContent,
        'align-items-center': !isQuotedContent
      }"
    >
      <div>
        <span *ngIf="showAvailableSerialNumbers"
          >{{ serialNumbersDisplay }}&nbsp;</span
        >
        <span
          *ngIf="!showAvailableSerialNumbers"
          class="cursor-pointer"
          (click)="NFTMOfNTooltip.toggle(); toggleShowMOfNNFTTooltip()"
          matTooltipClass="global__mat-tooltip global__mat-tooltip-font-size"
          [matTooltip]="mOfNNFTTooltip"
          #NFTMOfNTooltip="matTooltip"
        >
          <b
            >{{ postContent.NumNFTCopiesForSale }} of
            {{ postContent.NumNFTCopies }} available&nbsp;</b
          >
        </span>
        <span *ngIf="postContent.HasUnlockable" class="d-lg-inline-block d-none"
          >|&nbsp;</span
        >
        <span
          *ngIf="postContent.HasUnlockable"
          class="cursor-pointer d-lg-inline-block d-block mt-5px"
          (click)="tooltip.toggle(); toggleShowUnlockableContent()"
          matTooltipClass="global__mat-tooltip global__mat-tooltip-font-size"
          [matTooltip]="unlockableTooltip"
          #tooltip="matTooltip"
        >
          <i
            class="fas"
            [ngClass]="{
              'fa-lock':
                !decryptableNFTEntryResponses?.length || showUnlockableContent,
              'fa-unlock-alt':
                decryptableNFTEntryResponses?.length && !showUnlockableContent
            }"
          ></i>
          {{
            decryptableNFTEntryResponses?.length
              ? showUnlockableContent
                ? 'Hide Unlockable'
                : 'Show Unlockable'
              : 'Unlockable Content'
          }}
        </span>
        <div *ngIf="nftLastAcceptedBidAmountNanos">
          <b
            >Last price:
            {{ globalVars.nanosToDeSo(nftLastAcceptedBidAmountNanos) }} $DESO</b
          >
        </div>
        <div *ngIf="nftMinBidAmountNanos">
          <b
            >Min bid:
            {{ globalVars.nanosToDeSo(nftMinBidAmountNanos) }} $DESO</b
          >
        </div>
        <div *ngIf="nftBuyNowPriceNanos">
          <b
            >Buy Now Price:
            {{ globalVars.nanosToDeSo(nftBuyNowPriceNanos) }} $DESO</b
          >
        </div>
      </div>
      <button
        class="btn btn-primary font-weight-bold br-8px fs-13px"
        [ngClass]="{ 'mt-15px': isQuotedContent }"
        (click)="openPlaceBidModal($event)"
        *ngIf="showPlaceABid"
      >
        Place a bid
      </button>
      <button
        class="btn btn-primary font-weight-bold br-8px fs-13px"
        [ngClass]="{ 'mt-15px': isQuotedContent }"
        (click)="acceptTransfer($event)"
        *ngIf="acceptNFT"
      >
        <span class="d-flex align-items-center justify-content-center fs-12px">
          Accept Transfer
        </span>
      </button>
    </div>
    <div *ngIf="showUnlockableContent">
      <div
        *ngFor="let nftEntry of decryptableNFTEntryResponses"
        class="d-flex flex-row"
      >
        <div>#{{ nftEntry.SerialNumber }}:&nbsp;</div>
        <div
          [innerHTML]="nftEntry.DecryptedUnlockableText | sanitizeAndAutoLink"
        ></div>
      </div>
    </div>
    <div></div>
    <div
      *ngIf="showExpandedNFTDetails && (highBid || lowBid)"
      [ngClass]="{ 'pt-15px': globalVars.isMobile() }"
    >
      <div *ngIf="highBid != null">
        Highest: {{ globalVars.nanosToDeSo(highBid, 5) }} DESO
        <span class="text-grey7"
          >(~{{ globalVars.nanosToUSD(highBid, 2) }})</span
        >
      </div>
      <div *ngIf="lowBid != null">
        From: {{ globalVars.nanosToDeSo(lowBid, 5) }} DESO
        <span class="text-grey7"
          >(~{{ globalVars.nanosToUSD(lowBid, 2) }})</span
        >
      </div>
    </div>
  </div>
</div>
